"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
Object.defineProperty(exports, "__esModule", { value: true });
exports.householdMembersWidgetsNames = exports.widgetsNames = void 0;
exports.widgetsNames = ['householdMembers', 'household_save'];
exports.householdMembersWidgetsNames = [
    'personAge',
    'personNickname',
    'personHasDisability',
    'personSexAssignedAtBirth',
    'personGender',
    'personWorkerType',
    'personStudentType',
    'personSchoolType',
    'personOccupation',
    'personWorkerTypeBeforeLeave',
    'personEducationalAttainment',
    'personDrivingLicenseOwnership',
    'personCarSharingMember',
    'personTransitPasses',
    'personWorkPlaceType',
    'personWorkPlaceTypeBeforeLeave',
    'personSchoolPlaceType',
    'personUsualWorkPlaceName',
    'personUsualWorkPlaceGeography',
    'personUsualSchoolPlaceName',
    'personUsualSchoolPlaceGeography',
    'personTravelToWorkDays',
    'personRemoteWorkDays'
];
